// exclusive
export const random = (min: number, max: number) => {
  const range = max - min;
  const base = Math.floor(Math.random() * range);
  return base + min;
};

export const rollPercent = (percent: number) => {
  const result = random(0, 10000);
  return percent * 100 > result;
};
